module.exports = __webpack_public_path__ + "assets/img/0d66cdbfda876b88e872c94e2086cd17.png";